module.exports = __webpack_public_path__ + "img/agent-bg.3e0cb756.png";